import nodeHandlers from './handlers';

export default class NodeService {
  constructor(ctx) {
    const { store } = ctx;
    this.store = store;
    this.handlers = nodeHandlers.map((NodeHandler) => new NodeHandler(ctx));
  }

  async runNode(node, addToStack = true) {
    const firstHandler = this.handlers.find((handler) => handler.nodeType === node.type);
    const lastStackNode = this.store.getters['chatbotStore/lastStackNode'];

    const nextNode = firstHandler
      ? await firstHandler.handleNode(node, { addToStack })
      : this.store.getters['chatbotStore/nextNode'](node.id);

    if (nextNode) {
      /**
       * In the case of plugin nodes, checking to se if we already
       * added the result node in the stack or not. (The user might
       * hit refresh when the last node is a plugin node).
       */
      await this.runNode(nextNode, lastStackNode?.node?.id !== nextNode.id);
    } else {
      const currentStack = this.store.getters['chatbotStore/currentStack'];

      const index = currentStack?.findIndex(({ node: stackNode }) => stackNode.id === node.id);

      /**
       * Since we can change conversations between amps we can get race
       * conditions when nextNode getter s called, while also changing
       * the conversation before the the current on it's over. To prevent
       * this, before dispatching endConversation we check to see if
       * @param node it's still in the currentStack / currentAmp.
       */
      if (index < 0) {
        return;
      }

      this.store.dispatch('chatbotStore/endConversation');
    }
  }
}
